// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__34uhh","noInteraction":"EventWrapper_noInteraction__1WNbs"};